import { PayGiftCardOverpayment } from 'components/pay/giftcard/PayGiftCardOverpayment';
import { PayBaseModal } from 'components/pay/modals/PayBaseModal';
import { EGAEventName, useGAHelpers } from 'lib/useGAHelpers';
import React from 'react';

interface BasketGiftCardModalProps {
    open: boolean;
    onAccept: () => void;
    onCancel: () => void;
    gitcardBalance?: number;
    orderBalance?: number;
    giftCardNumber?: string;
}

export const BasketGiftCardModal: React.FC<BasketGiftCardModalProps> = ({
    open,
    onAccept,
    giftCardNumber,
    onCancel,
    gitcardBalance,
    orderBalance
}) => {
    const { logUserEvent } = useGAHelpers();
    const handleClose = React.useCallback(() => {
        onAccept();
        logUserEvent(EGAEventName.GiftcardOverpaymentAccepted);
    }, [logUserEvent, onAccept]);
    const handleCancel = React.useCallback(() => {
        onCancel();
        handleClose();
        logUserEvent(EGAEventName.GiftcardOverpaymentDeclined);
    }, [handleClose, logUserEvent, onCancel]);
    return (
        <PayBaseModal open={open} onClose={onAccept}>
            <PayGiftCardOverpayment
                giftCardNumber={giftCardNumber}
                giftcardBalance={gitcardBalance}
                balanceToPay={orderBalance}
                onCancel={handleCancel}
                onAccept={handleClose}
            />
        </PayBaseModal>
    );
};
